import React from 'react';
import { motion } from 'framer-motion';
export function HowItWorks() {
  const steps = [{
    num: '1',
    title: 'Identifica la Identidad',
    desc: 'Usa nuestras hojas de trabajo para definir el dolor subconsciente de tu comprador.'
  }, {
    num: '2',
    title: 'Configura la Estructura Andromeda',
    desc: 'Monta tu campaña Broad siguiendo la arquitectura 1-3-2 que te enseñamos.'
  }, {
    num: '3',
    title: 'Escala con Datos Reales',
    desc: 'Usa nuestras métricas de segunda generación para subir el presupuesto con seguridad.'
  }];
  return <section className="py-24 px-4" data-id="element-30">
      <div className="max-w-5xl mx-auto" data-id="element-31">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-32">
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-4" data-id="element-33">
            Cómo funciona
          </h2>
          <p className="text-xl text-slate-400" data-id="element-34">
            Tres pasos simples para dominar el algoritmo.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 relative" data-id="element-35">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute top-12 left-[10%] right-[10%] h-[2px] bg-gradient-to-r from-blue-500/0 via-blue-500/30 to-blue-500/0" data-id="element-36" />

          {steps.map((step, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.2
        }} className="relative flex flex-col items-center text-center" data-id="element-37">
              <div className="w-24 h-24 rounded-full bg-[#0a0e1a] border-4 border-[#161b22] flex items-center justify-center mb-6 relative z-10 shadow-[0_0_30px_-5px_rgba(59,130,246,0.3)]" data-id="element-38">
                <span className="text-4xl font-extrabold text-transparent bg-clip-text bg-gradient-to-br from-blue-400 to-purple-400" data-id="element-39">
                  {step.num}
                </span>
              </div>
              <h3 className="text-2xl font-bold text-white mb-4" data-id="element-40">
                {step.title}
              </h3>
              <p className="text-slate-400 leading-relaxed max-w-xs" data-id="element-41">
                {step.desc}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}